import 'core-js/stable';
import { tabbable } from '@/helpers/tabbable.umd';
import { focusTrap } from '@/helpers/focus-trap.umd';
import ClickToCopy from '@/modules/ClickToCopy';
import DragScroll from '@/modules/dragScroll';
import ImageCallout from '@/components/ImageCallout';
import HeroSlideshow from '@/components/HeroSlideshow';
import LazySrc from '@/modules/LazySrc';
import MenuItems from '@/modules/MenuItems';
import MobileNav from '@/components/MobileNav';
import Modal from '@/modules/Modal';
import NavOffset from '@/modules/NavOffset';
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.js';
import LoginCard from '@/components/LoginCard';
import LoginForm from '@/components/LoginForm';
import SearchForm from '@/components/SearchForm';
import SearchResults from '@/components/SearchResults';
import { sliders } from '@/modules/Sliders';
import LoadMore from '@/modules/LoadMore';
import Tables from '@/components/Tables';
import TaxSelector from '@/components/TaxSelector';
import MantlLinks from './modules/MantlLinks';


document.addEventListener('DOMContentLoaded', function () {
    const smoothScroll = new SmoothScroll('a[href*="#"]', {
        speed: 800,
    });

    LazySrc.init({
        selector: `[data-lazy-src], [data-lazy-srcset]`,
    });

    Modal.init({
        selector: `[data-modal-id]`,
    });
    
    ClickToCopy.init({
        selector: '.click-to-copy',
    });

    DragScroll.init({
        selector: '[data-js="draggable"]',
    });

    ImageCallout.init({
        selector: `[data-js="flush-image"] img`,
    });

    HeroSlideshow.init({
        selector: `[data-js="slideshow"]`,
    });

    LoadMore.init({
        selector: `[data-js="ajax-button"]`,
    });

    LoginForm.init();
    LoginCard.init({
        selector: `[data-js="login-card"]`,
        breakpoint: 992,
    });

    MenuItems.init({
        selector: `.menu-item.is-top-level`,
    });

    MobileNav.init({
        selector: `.c-mobile-nav`,
    });

    NavOffset.init({
        selector: `.c-nav`,
    });

    sliders.init();

    SearchForm.init();
    
    SearchResults.init();
    
    Tables.init({
        selector: '.wp-block-table',
    });

    TaxSelector.init({
        selector: '[data-js="tax-selector-form"]',
    });
    
    MantlLinks.init({
        selector: '[href*="?accountMinor"]',
    });

});

window.addEventListener('load', () => {});
